/**
 * Whether a pill is a STATE (keeps its tone) or a LABEL (takes its position's
 * colour: A blue, B violet, C cyan, then grey). The operator's rule,
 * 2026-10-10: label pills are standardised by position, state pills keep
 * green, amber and red so a fault still stands out. Said explicitly where a
 * call site knows; otherwise a dot or a green/amber/red tone makes a state.
 */
export function isStatePill(input: { tone: string; dot?: boolean; state?: boolean | undefined }): boolean {
  if (input.state !== undefined) return input.state;
  return Boolean(input.dot) || input.tone === 'success' || input.tone === 'warn' || input.tone === 'danger';
}
